// extracted by mini-css-extract-plugin
module.exports = {"card":"feature-card_card__34EdT","cardBody":"feature-card_cardBody__2DzXE","cardText":"feature-card_cardText__1j5KE","card-title":"feature-card_card-title__ay0wb"};